import { render, staticRenderFns } from "./NoDataHelpDesk.vue?vue&type=template&id=4138d120&scoped=true&"
import script from "./NoDataHelpDesk.vue?vue&type=script&lang=js&"
export * from "./NoDataHelpDesk.vue?vue&type=script&lang=js&"
import style0 from "./NoDataHelpDesk.vue?vue&type=style&index=0&id=4138d120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4138d120",
  null
  
)

export default component.exports